// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__19DEt","inner":"Form_inner__BvxN2","range":"Form_range__13tyJ","name":"Form_name__3DTqB","actions":"Form_actions__2ARjI"};